<div [ngClass]="containerClass" style="z-index:2000">
  <p *ngFor="let alert of alertService.lAlerts">
    <ngb-alert (closed)="alertService.close(alert)" [type]="alert.type">{{ alert.message }}</ngb-alert>
  </p>
</div>

